<template lang="pug">
  div#Form

    //- Name
    div.form-field
      input(@click="UpdateNameLabel"
            v-on-click-outside="ConfirmName"
            v-model="UserName"
            type="text" name="text" required)
      label(for="field-text") {{ this.name }}


    //- Subject
    div.form-field.subject
      input(@click="Cool"
            v-model="UserSubject"
            v-on:change="Cool"
            type="text" name="text" required)
      label {{ this.subject }}



    div.form-field
      textarea(name="message" id="message" cols="30" rows="10" :placeholder="this.textarea")



    //- Email
    div.form-field
      //- div.form-field.form-field-invalid(data-validationError="This field is invalid")
      input(@click="UpdateEmailLabel"
            v-on-click-outside="ConfirmEmail"
            v-model="UserMail"
            type="text" name="text" required)
      label {{ this.email }}


    p.antispam Leave this empty
      input(type="text" name="url")

</template>



<script>
export default {
  name: 'ContactForm',

  data: () => ({
    // Form model
    UserName: '',
    UserSubject: '',
    UserMail: '',

    // Robot messages
    name: 'What is your name?',
    subject: 'How can I help?',
    textarea: 'Explain.',
    email: 'Where should I reply?'
  }),

  methods: {
    // Name UXified
    UpdateNameLabel () {
      this.name = 'Don\'t be shy, I like whole names!'
      if (this.UserName !== '') {
        this.name = 'People normally doesn\'t change it\'s name...'
      }
    },
    ConfirmName () {
      if (this.UserName !== '') {
        this.name = 'Nice to meet you, ' + this.UserName.split(' ').slice(0, 1).join(' ') + '!'
      } else {
        this.name = 'What is your name?'
      }
    },

    // Email UXified
    UpdateEmailLabel () {
      this.email = 'Definitely not asdajasj@asdsja.com'
      if (this.UserMail !== '') {
        this.email = 'Don\'t worry, your mail is HTTPS protected!'
      }
    },
    ConfirmEmail () {
      if (this.UserMail !== '') {
        this.email = 'I won\'t store your direction anywhere.'
      } else {
        this.email = 'Where should I reply?'
      }
    },

    Cool () {
      this.subject = 'I want to hear your thoughts.'
      if (this.UserSubject !== '') {
        this.textarea = 'Maybe a more detailed explanation?'
      }
    }
  }
}
</script>



<style lang="sass" scoped>
#Form
  ::selection
    background-color: blue
  input
    &[type="text"]



// Sad but true
.antispam
  display: none
  position: absolute
  top: -3000px
  left: -3000px
</style>



<style lang="scss" scoped>
$material-form-label-focus: #F55D07;
$material-form-line: white;
$material-form-line-focus: $material-form-label-focus;
$material-form-input-text: white;
$material-form-input-text-focus: white;
$form-invalid: #d50000;

$label_Offset: 35px;
$material-textInputPaddingTopBottom: 10px;



.form-field {
  font-size: 19px;
  position: relative;
  padding: $label_Offset 0 10px 0;

  &:after {
    color: $form-invalid;
    content: "\00A0";
    display: block;
    font-size: 12px;
    padding-top: 5px;
  }

  label {
    position: absolute;
    top: $label_Offset + $material-textInputPaddingTopBottom;
    left: 0px;
    transition: .2s ease all;
    pointer-events: none;
  }

  input {
    font-size: 19px;
    padding:$material-textInputPaddingTopBottom 0 $material-textInputPaddingTopBottom 0;
    width: 100%;
    border: none;
    color: $material-form-input-text;

    border-bottom: 1px solid transparent;
    border-image-source: linear-gradient(to right, #F55D07, #F3BF00);
    border-image-slice: 20;
    outline: none;

    &:invalid{
      outline: none;
      box-shadow: none;
    }
    &:valid, &:focus{
      & ~ label{
        top: $label_Offset - ($material-textInputPaddingTopBottom + 5);
        font-size: 12px;
      }
    }
    &:focus{
      outline:none;
      color:$material-form-input-text-focus;


      & ~ label{
        color:$material-form-label-focus;
      }
    }
  }

  &.form-field-invalid{
    color: $form-invalid;
    &::after{
      content:attr(data-validationError);
    }
    input:focus ~ label{
      color: $form-invalid;
    }
  }
}

textarea {
  width: 100%;
  border: none;
  color: $material-form-input-text;
  border: 1px solid transparent;
  border-image-source: linear-gradient(to right, #F55D07, #F3BF00);
  border-image-slice: 20;
  outline: none;
  &::placeholder{
    color: $material-form-input-text;
    padding: 4px
  }
}


.subject {
  padding-bottom: 0;
  &:after {
    display: none
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ContactForm.vue